import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiClient } from '../../api/client';
import SectionHeader from './SectionHeader';

const hhmm = (ts) => new Date(Number(ts) * 1000).toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' });
const ago = (ts, now) => {
    const m = Math.max(0, Math.round((now - Number(ts)) / 60));
    if (m < 1) return 'şimdi';
    if (m < 60) return `${m} dk`;
    if (m < 1440) return `${Math.round(m / 60)} sa`;
    return `${Math.round(m / 1440)} g`;
};
const KIND_ICON = { open: '🟢', close: '🔴', tp1: '🎯', pending: '🔭', cancel: '✖', lock: '🔒', tier1: '🪜', start: '▶️', stop: '⏹' };

function Row({ icon, text, ts, now, tag, onClick, testId }) {
    return (
        <li>
            <button onClick={onClick} data-testid={testId}
                    className="w-full flex items-start gap-2 rounded-md px-2 py-1.5 text-left hover:bg-slate-800/80 transition-colors">
                {icon && <span className="text-sm leading-5 shrink-0">{icon}</span>}
                <span className="min-w-0 flex-1 text-xs text-slate-200 leading-5 truncate" title={text}>{text}</span>
                <span className="shrink-0 text-[10px] text-slate-500 font-mono leading-5" title={hhmm(ts)}>{ago(ts, now)}{tag ? ` · ${tag}` : ''}</span>
            </button>
        </li>
    );
}

/** Ana sayfa canlı akışı: botların son 5 açılış/kapanışı + radarın son 5 olayı (15 sn'de bir yenilenir). */
export default function RecentEvents({ onSelect }) {
    const navigate = useNavigate();
    const [data, setData] = useState(null);
    const [err, setErr] = useState(null);
    useEffect(() => {
        let alive = true;
        const load = async () => {
            try {
                const r = await apiClient.get('/home/events', { params: { limit: 5 } });
                if (alive) { setData(r.data); setErr(null); }
            } catch (e) {
                if (alive) setErr('akış alınamadı');
            }
        };
        load();
        const id = setInterval(load, 15000);
        return () => { alive = false; clearInterval(id); };
    }, []);
    const now = data?.server_time || Date.now() / 1000;
    return (
        <div className="space-y-2" data-testid="home-recent-events">
            <SectionHeader id="son-olaylar" emoji="🛰" title="Son olaylar — canlı akış" subtitle="Botun son açılış/kapanışları ve radarın son yakaladıkları. 15 saniyede bir yenilenir; satıra tıkla, ilgili sayfa açılsın." />
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-2.5">
                <div className="rounded-xl border border-slate-700 bg-slate-800/50 p-2" data-testid="home-events-bot">
                    <div className="px-2 py-1 text-[10px] uppercase tracking-[0.18em] text-slate-400">🤖 Botlar · son 5 açılış / kapanış</div>
                    {err && <div className="px-2 py-2 text-xs text-rose-300">{err}</div>}
                    {data && data.bot.length === 0 && <div className="px-2 py-3 text-xs text-slate-500">Henüz bot işlemi yok.</div>}
                    {!data && !err && <div className="px-2 py-3 text-xs text-slate-500">yükleniyor…</div>}
                    <ul className="space-y-0.5">
                        {(data?.bot || []).map((e, i) => (
                            <Row key={`${e.ts}-${i}`} icon={KIND_ICON[e.kind] || '•'} text={e.text} ts={e.ts} now={now}
                                 tag={e.source === 'scalper' ? '⚡ hızlı' : e.source === 'range' ? '📐 aralık' : 'bot'} onClick={() => navigate(e.source === 'scalper' ? '/hizli-bot' : e.source === 'range' ? '/aralik-bot' : '/bot')} testId={`home-event-bot-${i}`} />
                        ))}
                    </ul>
                </div>
                <div className="rounded-xl border border-slate-700 bg-slate-800/50 p-2" data-testid="home-events-radar">
                    <div className="px-2 py-1 text-[10px] uppercase tracking-[0.18em] text-slate-400">📡 Radar · son 5 olay</div>
                    {data && data.radar.length === 0 && <div className="px-2 py-3 text-xs text-slate-500">Radar henüz olay yakalamadı.</div>}
                    {!data && !err && <div className="px-2 py-3 text-xs text-slate-500">yükleniyor…</div>}
                    <ul className="space-y-0.5">
                        {(data?.radar || []).map((e, i) => (
                            <Row key={`${e.ts}-${i}`} icon={null} text={e.text} ts={e.ts} now={now}
                                 tag={e.chg_1h_after != null ? `1 sa sonra ${Number(e.chg_1h_after) >= 0 ? '+' : ''}${Number(e.chg_1h_after).toFixed(1)}%` : null}
                                 onClick={() => onSelect?.(e.symbol)} testId={`home-event-radar-${i}`} />
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
}
